import { render, staticRenderFns } from "./ItemEnhance.vue?vue&type=template&id=bea00fc2&scoped=true&"
import script from "./ItemEnhance.vue?vue&type=script&lang=js&"
export * from "./ItemEnhance.vue?vue&type=script&lang=js&"
import style0 from "./ItemEnhance.vue?vue&type=style&index=0&id=bea00fc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea00fc2",
  null
  
)

export default component.exports